//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState,
  mapActions,
} from 'vuex'

import {
  ORDER_LIST,
  WISHLIST_LIST,
  FEEDBACK_LIST_VIEW,
  USER_DATA,
} from '@app/Buyer/routes'

export default {
  name: 'UserAccountActions',
  props: ['userLink', 'sellerLinkAuth', 'sellerLinkRegister'],
  data() {
    return {
      links: [
        // {
        //   title: this._('Главная'),
        //   tag: 'UserInfo',
        //   path: DASHBOARD_VIEW_NAME,
        //   iconComponent: 'un-icon-apps-v2',
        // },
        {
          title: this._('Мої замовлення'),
          tag: 'UserInfo',
          path: ORDER_LIST,
          iconComponent: 'un-icon-history',
        },
        {
          title: this._('Обране'),
          iconComponent: 'un-icon-heart',
          path: WISHLIST_LIST,
        },
        {
          title: this._('Відгуки'),
          tag: 'UserOrderList',
          path: FEEDBACK_LIST_VIEW,
          iconComponent: 'un-icon-comment',
        },
        {
          title: this._('Налаштування'),
          tag: 'UserOrderList',
          path: USER_DATA,
          iconComponent: 'un-icon-settings',
        },
      ],
    }
  },
  computed: {
    ...mapState('staff', [
      'user',
      'oppositeAccountExists',
    ]),
  },
  created() {
    this.getUserInfo()
    this.getOppositeAccount()
  },
  methods: {
    ...mapActions('staff', [
      'updateUserInfo',
      'getUserInfo',
      'getOppositeAccount',
    ]),
  },

}
